import React from 'react';

// Single navbar requirement: topbar merged into footer
const Topbar = () => null;

export default Topbar;
